export enum AGENT_LIBRARY {
    /**
     * @value Agent Library
     * @description Title of the page section
     */
    AGENT_LIBRARY = 'AGENT_LIBRARY.AGENT_LIBRARY',
    /**
     * @value Pick an AI agent and begin chatting to get quick answers, guidance, and support for your daily work.
     * @description Subtitle for the front office agent library page
     */
    AGENT_LIBRARY_PAGE_SUBTITLE = 'AGENT_LIBRARY.AGENT_LIBRARY_PAGE_SUBTITLE',
    /**
     * @value Agents automate tasks and enhance your workflow. Agents will appear in this library once they are created.
     * @description Message displayed in agent library when no agents are available. Description of the message
     */
    EMPTY_STATE_DESC = 'AGENT_LIBRARY.EMPTY_STATE_DESC',
    /**
     * @value No Agents yet
     * @description Displayed when agent library has no agents to display. Title of the message.
     */
    EMPTY_STATE_TITLE = 'AGENT_LIBRARY.EMPTY_STATE_TITLE',
    /**
     * @value Start Chat
     * @description Label of the button to open the ai chat.
     */
    START_CHAT = 'AGENT_LIBRARY.START_CHAT',
}
